/* eslint-disable max-lines-per-function */
import React, { useState } from 'react';
import { connect } from 'react-redux';

const VETTED_STATUS = 'passed-vetting';

const CopyButton = ({ text, copyFn }) => {
  return (
    <button
      data-clipboard-target='.preview-area__code'
      type='button'
      className='copy-btn'
      onClick={copyFn}
    >
      {text}
    </button>
  );
};

const InputSection = () => (
  <div className='input-section'>
    <h2>How to upload code to website builders</h2>
    <ul
      style={{
        textAlign: 'left',
        marginBottom: 0,
      }}
    >
      <li>
        <b>Squarespace</b>
        {' - '}
        <a
          rel='noopener noreferrer'
          target='_blank'
          href='https://support.squarespace.com/hc/en-us/articles/206543167-Using-Code-Blocks'
        >
          Add a Code Block.
        </a>
      </li>
      <li>
        <b>Wix</b>
        {' - '}
        <a
          rel='noopener noreferrer'
          target='_blank'
          href='https://support.wix.com/en/article/adding-html-code'
        >
          Add HTML Code.
        </a>
      </li>
      <li>
        <b>WordPress</b>
        {' - '}
        <a
          rel='noopener noreferrer'
          target='_blank'
          href='https://en.support.wordpress.com/wordpress-editor/blocks/code-block/'
        >
          Add a Code Block.
        </a>
      </li>
      <li>
        <b>Weebly</b>
        {' - '}
        <a
          rel='noopener noreferrer'
          target='_blank'
          href='https://weeblytutorials.com/add-html-to-weebly/'
        >
          Add the Embed Code element.
        </a>
      </li>
    </ul>
  </div>
);

const providerUrl = ({ slug, primary_profession, type }) => {
  const primaryProfession = primary_profession?.slug ? primary_profession.slug : 'therapist';
  return type === 'practice'
    ? `${process.env.ZENCARE_WEBSITE_URL}/practice/${slug}`
    : `${process.env.ZENCARE_WEBSITE_URL}/provider/${primaryProfession}/${slug}`;
};

const constructSrc = (color, isVetted) =>
  `https://zencare.s3.us-east-2.amazonaws.com/badges/therapist_${
    isVetted ? '' : 'unvetted_'
  }${color}.png`;

const IFrameContent = ({ color, provider }) => {
  const isVetted = (provider.custom_content.vetting_status = VETTED_STATUS);
  return (
    <iframe
      title='Zencare Therapist Badge'
      style={{ width: '250px', height: '86px', border: 'none' }}
      srcDoc={`<a href=${providerUrl(
        provider
      )} target='_blank' style='display:block; width:100%; height:100%;'><img src=${constructSrc(
        color,
        isVetted
      )} alt='Zencare Therapist Badge' style='width:100%; height:100%; border:0;'></a>`}
    ></iframe>
  );
};

const getIframeHtml = (color, provider) => {
  const isVetted = (provider.custom_content.vetting_status = VETTED_STATUS);
  const url = providerUrl(provider);
  const imgSrc = constructSrc(color, isVetted);
  return `<iframe title="Zencare Therapist Badge" style="width:250px; height:86px; border:none;" srcdoc='<a href="${url}" target="_blank" style="display:block; width:100%; height:100%;"><img src="${imgSrc}" alt="Zencare Therapist Badge" style="width:100%; height:100%; border:0;"></a>'></iframe>`;
};

export const WebBadge = ({ provider }) => {
  const [textBlueButton, setTextBlueButton] = useState('Copy Code!');
  const [textWhiteButton, setTextWhiteButton] = useState('Copy Code!');

  const resetButtonText = () => {
    setTextBlueButton('Copy Code!');
    setTextWhiteButton('Copy Code!');
  };

  const onCopy = (elementId, setButtonText) => {
    const textContent = document.getElementById(elementId).innerText;
    navigator.clipboard.writeText(textContent);

    resetButtonText();
    setButtonText('Copied!');
  };

  const CodeBlock = ({ id, color, provider }) => {
    return (
      <div className='code-container'>
        <code id={id} className='preview-area__code'>
          {getIframeHtml(color, provider)}
        </code>
      </div>
    );
  };

  return (
    <div
      id='static-page'
      className='main-content web-badge'
      style={{
        maxWidth: '1080px',
        margin: '0 auto',
      }}
    >
      <h1 style={{ whiteSpace: 'pre-wrap' }}>Zencare web badge</h1>
      <p style={{ whiteSpace: 'pre-wrap' }}>
        Add your Zencare badge on your website to increase your search rankings! See below for our
        guide.
      </p>
      <p style={{ whiteSpace: 'pre-wrap' }}>
        Questions? Email{' '}
        <a href='mailto:support@zencare.co' rel='noopener noreferrer' target='_blank'>
          support@zencare.co
        </a>{' '}
        for help from our team!
      </p>
      <div id='app'>
        <section className='preview-section'>
          <div className='title-number'>
            <h2>Turquoise Web Badge</h2>
            <CopyButton
              copyFn={() => onCopy('codeBlue', setTextBlueButton)}
              text={textBlueButton}
            />
          </div>

          <div className='preview'>
            <IFrameContent color={'turquoise'} provider={provider} />
            <CodeBlock id='codeBlue' color='turquoise' provider={provider} />
          </div>
        </section>

        <section className='preview-section white'>
          <div className='title-number'>
            <h2>White Web Badge</h2>{' '}
            <CopyButton
              copyFn={() => onCopy('codeWhite', setTextWhiteButton)}
              text={textWhiteButton}
            />
          </div>

          <div className='preview'>
            <IFrameContent color={'white'} provider={provider} />
            <CodeBlock id='codeWhite' color='white' provider={provider} />
          </div>
        </section>
        <InputSection />
      </div>
    </div>
  );
};

const mapStateToProps = ({ auth, main }) => ({
  provider: main.provider,
});

export default connect(mapStateToProps, null)(WebBadge);
